import { toRaw } from "vue";

/**
 * 转化分组表格数据
 * @param sheetData
 */
export function convertGroupSheetData(sheetData: Array<any>): any {
	let groupList: any[] = [];
	let tmpMap = new Map();
	let currindex = 0;

	sheetData.every((item: any) => {
		if (!tmpMap.has(item.groups)) {
			tmpMap.set(item.groups, currindex);
			currindex++;
			groupList.push({ name: item.groups, samples: [] });
		}
		groupList[tmpMap.get(item.groups)].samples.push(item.samples);
		return true;
	});

	return groupList;
}

/**
 * 转换样本数据
 * @param flag 
 * @param sheetData 
 */
export function convertSampleData(
	flag: string,
	sheetData: Array<any>
): Array<any> {
	let sampleDataList: any[] = [];

	sheetData.every((rowDataSrc: any) => {
		let rowDataSrcRaw = toRaw(rowDataSrc);
		let rowDataDes: any = { name: rowDataSrcRaw[flag], dataList: [] };
		delete rowDataSrcRaw[flag];

		let colKeys = Object.keys(rowDataSrcRaw);
		colKeys.every((colKey: string) => {
			rowDataDes.dataList.push({
				sample:colKey,
				value:rowDataSrcRaw[colKey]
			});

			return true;
		});

		sampleDataList.push(rowDataDes);

		return true;
	});

	return sampleDataList;
}
